import { BrandModel } from "@/types/brand";
import Image from "next/image";
import React from "react";
import { Link } from "@/i18n/navigation";

const BrandCard = ({ brand }: { brand: BrandModel }) => {
  return (
    <Link
      href={`/brands/${brand.id}`}
      className="group relative flex flex-col items-center"
    >
      {/* Tech Glow Background */}
      <div
        className="
      absolute inset-0
      rounded-2xl
      opacity-0 group-hover:opacity-100
      transition duration-500
      bg-gradient-to-br from-primary/20 via-transparent to-cyan-400/20
      blur-2xl
      scale-90 group-hover:scale-100
    "
      />

      {/* Logo Container */}
      <div
        className="
      relative w-[95px] h-[95px]
       lg:w-[120px] lg:h-[120px]
      rounded-full
      
      border border-gray-200
      flex items-center justify-center
      overflow-hidden
      transition-all duration-500 ease-out
      shadow-[0_8px_30px_rgba(0,0,0,0.06)]
      group-hover:-translate-y-1
      group-hover:shadow-[0_25px_60px_rgba(0,0,0,0.15)]
    "
      >
        {/* Animated Ring */}
        <div
          className="
         absolute inset-0 rounded-full
        border border-primary/30
        opacity-0 group-hover:opacity-100
        animate-pulse
      "
        />

        <Image
          src={brand.logo_url}
          alt={brand.name}
          fill
          className="
        w-full h-full object-cover 
        transition-all duration-500 ease-out
        group-hover:scale-105 
      "
        />
      </div>

      {/* Brand Name */}
      <h3
        className="
      mt-5 text-sm sm:text-base font-semibold
      text-gray-700
      transition-all duration-300
      group-hover:text-primary
      group-hover:tracking-wide
    "
      >
        {brand.name}
      </h3>
    </Link>
  );
};

export default BrandCard;
